import { useQuery } from '@tanstack/react-query';

import { zoningApi } from './../../apis/zoning-api';
import { analysisKeys } from './../../keys/analysis-keys';

interface UseZoningParams {
  analysisId: number | null;
  enabled: boolean;
}

export function useZoning(params: UseZoningParams) {
  const query = useQuery({
    ...analysisKeys.zoning(params.analysisId as number),
    enabled: params.analysisId !== null && params.enabled,
  });

  return query;
}

export default useZoning;
